/** @jsxImportSource @emotion/react */

import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { TOKEN_NAMES } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import { getTokenIcon } from "../../../utils/tokenIconUtils";
import { reviewText, reviewUsdFont, tradeHeaderFont } from "../../../config/commonCSS";
import { WrapProps } from "../Wrap";
import { ReviewAmountLabel } from "./ReviewAmountLabel";

export const WrapReview: React.FC<WrapProps> = ({ takerToken, makerToken }) => {
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const tokens = GlobalStore.useState(s => s.tokens);
  const formattedAmount = wrapQuote?.amount?.value.toDP(5).toString();
  const theme = GlobalStore.useState(s => s.theme);
  const tokenWithUsdPrice = tokens?.[makerToken] ?? tokens?.[takerToken];
  const usdVal = tokenWithUsdPrice?.priceUsd.value.mul(Number(wrapQuote?.amount ?? Amount.ZERO));

  return (
    <div className="review-order">
      <div className="sp10"></div>
      <div>
        <div className="review-pay br-14">
          <p className="trade-box-header" css={tradeHeaderFont(theme)}>
            You Pay
          </p>
          <div className="d-flex justify-content-between">
            <span className="pay-review-token me-3" css={reviewText(theme)}>
              <img
                width="32"
                height="32"
                src={getTokenIcon(takerToken, tokens)}
                alt={takerToken}
                className="me-2"
              />
              {TOKEN_NAMES[takerToken]}
            </span>
            <div className="d-flex flex-column align-items-end">
              <div>
                <ReviewAmountLabel
                  formattedAmount={formattedAmount ?? ""}
                  tokenTicker={takerToken}
                />
              </div>
              {usdVal?.gt(0) && (
                <span className="pay-review-usd" css={reviewUsdFont(theme)}>
                  ${usdVal.toFixed(2)}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="sp10"></div>
        <div className="review-pay br-14">
          <p className="trade-box-header" css={tradeHeaderFont}>
            You Receive Exactly
          </p>
          <div className="d-flex justify-content-between">
            <span className="pay-review-token me-3" css={reviewText}>
              <img
                width="32"
                height="32"
                src={getTokenIcon(makerToken, tokens)}
                alt={makerToken}
                className="me-2"
              />
              {TOKEN_NAMES[makerToken]}
            </span>
            <div className="d-flex flex-column align-items-end">
              <div>
                <ReviewAmountLabel
                  formattedAmount={formattedAmount ?? ""}
                  tokenTicker={makerToken}
                />
              </div>
              {usdVal?.gt(0) && (
                <span className="pay-review-usd" css={reviewUsdFont}>
                  ${usdVal.toFixed(2)}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
